const sliderWrapper = document.querySelector("#featured-products-slider");

const slidesPerView = parseInt(sliderWrapper.closest('.featured-products').dataset.slidesPerView, 10) || 2;

new Swiper(sliderWrapper, {
    slidesPerView: 2,
    spaceBetween: 12,
    loop: false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    breakpoints: {
        767: {
            spaceBetween: 16,
            slidesPerView: 3
        },
        1024: {
            slidesPerView: slidesPerView
        }
    }
});

if (sliderWrapper.querySelectorAll(".swiper-pagination-bullet").length < 2) {
    sliderWrapper.querySelector(".swiper-pagination").style.display = "none";
}